import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Table } from 'semantic-ui-react';
import CopyContentComponent from '../../../misc/CopyContent.component';
import { BeneficialOwnersView } from '../../../../types/BeneficialOwners';

type BeneficialOwnersProps = {
    data?: BeneficialOwnersView[];
    copy?: boolean;
};
export default function LeadBeneficialOwnerComponent(owners: BeneficialOwnersProps): React.ReactElement {
    const { t } = useTranslation();

    function createValue(value?: string): React.ReactElement {
        return owners.copy ? <CopyContentComponent>{value || ''}</CopyContentComponent> : <>{value || ''}</>;
    }

    return (
        <Card fluid>
            <Card.Content>
                <Card.Header content={t('lead.detail.box.company.beneficialOwners.headline')} />
                <Card.Description>
                    <Table celled striped columns={3}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell
                                    content={t('lead.detail.box.company.beneficialOwners.person.firstName')}
                                />
                                <Table.HeaderCell
                                    content={t('lead.detail.box.company.beneficialOwners.person.lastName')}
                                />
                                <Table.HeaderCell
                                    content={t('lead.detail.box.company.beneficialOwners.person.postalWithLocality')}
                                />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {owners.data?.map((value, index) => (
                                <Table.Row key={index}>
                                    <Table.Cell singleLine content={createValue(value?.firstName)} />
                                    <Table.Cell singleLine content={createValue(value?.lastName)} />
                                    <Table.Cell singleLine content={createValue(value?.location)} />
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </Card.Description>
            </Card.Content>
        </Card>
    );
}
